(function(){
    'use strict';
    angular.module('app').controller('RPEditDriverAddressModalController', RPEditDriverAddressModalController);
    RPEditDriverAddressModalController.$inject = [
        'driverData',
        '$uibModalInstance'
    ];
    function RPEditDriverAddressModalController(
        driverData,
        $uibModalInstance
    ) {
        const vm = this; 

        vm.save = save;
        vm.close = close;

        init();

        function init() {
            vm.driver = driverData;
        }

        function save(form) {
            if (form.$invalid) {
                form.$setSubmitted();
                return;
            }

            $uibModalInstance.close(vm.driver);
        }

        function close() {
            $uibModalInstance.dismiss();
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/route-planning/modal/RPEditDriverAddressModalController.js